import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'
import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || 'https://cdfengtai.com/api/api', // 修改为正确的后端服务地址
  //baseURL: 'http://localhost:8200/api', // 修改为正确的后端服务地址
  timeout: 15000, // 请求超时时间
  withCredentials: false // 跨域请求是否携带cookie
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = getToken()
    // 如果有token则添加到请求头
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    
    // 添加时间戳，避免缓存
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: Date.now()
      }
    }
    
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 如果响应类型是blob（文件下载），直接返回响应数据
    if (response.config.responseType === 'blob') {
      return response.data;
    }
    
    // 验证码接口特殊处理
    if (response.config.url.includes('/captcha')) {
      return response.data;
    }
    
    const res = response.data
    
    // 检查响应状态码
    if (res.code !== 200 && res.code !== 20000) {
      // 登录接口和验证码接口错误不在这里显示消息，避免重复提示
      if (!response.config.url.includes('/auth/login') && !response.config.url.includes('/captcha')) {
        Message({
          message: res.message || '请求失败',
          type: 'error',
          duration: 5 * 1000
        })
      }
      
      // 401: 未登录或token过期
      if (res.code === 401) {
        // 清除token并跳转到登录页面
        localStorage.removeItem('token')
        // 调用user模块的resetToken action清除用户信息和权限
        import('@/store').then(module => {
          const store = module.default;
          store.dispatch('user/resetToken').then(() => {
            // token清除后跳转登录页
            router.replace('/login');
          });
        });
      }
      
      return Promise.reject(new Error(res.message || '请求失败'))
    } else {
      return res
    }
  },
  error => {
    // 创建一个错误消息
    let errorMessage = '网络连接失败，请检查您的网络设置';
    
    if (error.response) {
      // 如果有响应状态码
      switch (error.response.status) {
        case 401:
          errorMessage = '未授权，请重新登录';
          // 清除token并跳转到登录页面
          // 调用user模块的resetToken action清除用户信息和权限
          import('@/store').then(module => {
            const store = module.default;
            store.dispatch('user/resetToken').then(() => {
              // token清除后跳转登录页
              router.replace('/login');
            });
          });
          break;
        case 403:
          errorMessage = '拒绝访问';
          break;
        case 404:
          errorMessage = '请求的资源不存在';
          break;
        case 500:
          errorMessage = '服务器内部错误';
          break;
        default:
          errorMessage = error.response.data.message || `请求失败(${error.response.status})`;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    // 对于二进制流响应的请求，不显示错误消息，而是将其传递给调用方处理
    if (error.config && error.config.responseType === 'blob') {
      return Promise.reject(error);
    }
    
    // 登录接口和验证码接口错误不在这里显示消息，避免重复提示
    if (!error.config || (!error.config.url.includes('/auth/login') && !error.config.url.includes('/captcha'))) {
      Message({
        message: errorMessage,
        type: 'error',
        duration: 5 * 1000
      })
    }
    
    return Promise.reject(error)
  }
)

export default service